import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-preview-email-template',
  templateUrl: './preview-email-template.component.html',
  styleUrls: ['./preview-email-template.component.scss']
})
export class PreviewEmailTemplateComponent implements OnChanges {

  sanitizedData: SafeHtml = '';
 @Input() type: string = 'email';
 @Input() templateName = 'Template';
 @Input() attachments: any[] = [];
 previewAttachments: any[] = [];
   selectedIndex: any;
 @Input() device: 'desktop' | 'tablet' | 'mobile' = 'desktop';
@Output() close: EventEmitter<any> = new EventEmitter();

  constructor(
    private sanitizer: DomSanitizer,
    private modalService: NgbModal
  ) {}

    @Input() processedData: any;

    ngOnInit() {
      this.sanitizedData = this.processedData || '';
    }

    ngOnChanges(changes: SimpleChanges) {
      if (changes['processedData']) {
        this.sanitizedData = this.processedData || '';
      }
    }

    setDevice(device: 'desktop' | 'tablet' | 'mobile') {
      this.device = device;
    }

    reloadPreview() {
      const current = this.sanitizedData;
      this.sanitizedData = this.sanitizer.bypassSecurityTrustHtml('');
      setTimeout(() => {
        this.sanitizedData = current;
      });
    }
    
    closePopup() { this.close.emit()}
    
    // Get file icon class based on extension
    getFileIcon(fileName: string): string {
      if (!fileName) return 'fa-file';
      
      const ext = fileName.toLowerCase();
      
      if (ext.endsWith('.pdf')) return 'fa-file-pdf text-danger';
      if (ext.endsWith('.doc') || ext.endsWith('.docx')) return 'fa-file-word text-primary';
      if (ext.endsWith('.xls') || ext.endsWith('.xlsx')) return 'fa-file-excel text-success';
      if (ext.endsWith('.ppt') || ext.endsWith('.pptx')) return 'fa-file-powerpoint text-warning';
      if (ext.endsWith('.jpg') || ext.endsWith('.jpeg') || ext.endsWith('.png') || ext.endsWith('.gif')) return 'fa-file-image text-info';
      
      return 'fa-file text-secondary';
    }
    
    // Preview attachment in modal
    previewAttachment(attachment: any, previewModal: any) {
      if (!attachment || !attachment.url) {
        return;
      }
      
      const attachmentData = {
        name: attachment.fileName,
        file_name: attachment.fileName,
        url: attachment.url,
        publicUrl: attachment.url,
        type: this.getFileType(attachment.fileName),
        mime_type: this.getMimeType(attachment.fileName)
      };
      
      // Open modal
      const modalRef = this.modalService.open(previewModal, { 
        size: 'xl', 
        centered: true,
        backdrop: 'static',
        windowClass: 'attachment-preview-modal'
      });
      this.previewAttachments = [];
      this.previewAttachments.push(attachmentData);
      this.selectedIndex = 0;

    }
    
    // Get file type from filename
    getFileType(fileName: string): string {
      if (!fileName) return 'other';
      
      const ext = fileName.toLowerCase();
      const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'];
      const videoExts = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv'];
      const audioExts = ['mp3', 'wav', 'ogg', 'aac'];
      
      if (imageExts.some(e => ext.endsWith('.' + e))) return 'image';
      if (ext.endsWith('.pdf')) return 'pdf';
      if (videoExts.some(e => ext.endsWith('.' + e))) return 'video';
      if (audioExts.some(e => ext.endsWith('.' + e))) return 'audio';
      
      return 'other';
    }
    
    // Get MIME type from filename
    getMimeType(fileName: string): string {
      if (!fileName) return 'application/octet-stream';
      
      const ext = fileName.toLowerCase();
      const mimeTypes: { [key: string]: string } = {
        'pdf': 'application/pdf',
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'png': 'image/png',
        'gif': 'image/gif',
        'doc': 'application/msword',
        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'xls': 'application/vnd.ms-excel',
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'ppt': 'application/vnd.ms-powerpoint',
        'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'mp4': 'video/mp4',
        'mp3': 'audio/mpeg'
      };
      
      for (const [extension, mimeType] of Object.entries(mimeTypes)) {
        if (ext.endsWith('.' + extension)) {
          return mimeType;
        }
      }
      
      return 'application/octet-stream';
    }
    
}
